import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { STORED_PATHNAME_KEY } from '../constants';

function RedirectToStoredPathname(props) {
    const {} = props,
        { pathname } = useLocation(),
        storedPathname = sessionStorage.getItem(STORED_PATHNAME_KEY);

    if (!storedPathname) return null;
    if (pathname == storedPathname) return null;

    sessionStorage.removeItem(STORED_PATHNAME_KEY);

    console.log('Redirecting back to stored path: ', storedPathname);
    return <Redirect to={storedPathname} />;
}

export default RedirectToStoredPathname;
